import { post } from "../web.request"

export const uploadImageApiHandler = (data) => {
    return post(`https://sizesutraapi.mobiginie.com/measurements/`, data);
};

